export default {
    login: {
        login: 'Log In',
        username: 'User Name',
        password: 'Password',
        fgpassword: 'Forgot Your Password?',
        bsilogin: 'BSI Login',
    },
    home: {
        ISO: 'ISO14064-1',
        PAS: 'PAS2060',
        enterprise: '企业',
        enterpriseinPro: '进行中的企业',
        allenterprise: '全部企业',
        Expandmore: '展开更多',
        putaway: '收起',
        Certificationprogress: '认证进度',
        dynamic: '动态',
        calendar: '日历',
        date: '小时前',
        minutes: '分钟前',
        scene: '现场检查',
        longrange: '远程检查',
        confirmed: 'Application to be confirmed',
        confend: '待签约',
        Review: 'Document Review',
        Verification: 'Stage1 Verification ',
        Stage2Verification: 'Stage2 Verification',
        InternalReview: 'Internal Review(独立技术评审）',
        CertificateIssuance: 'Certificate Issuance',
    },
    iso: {
        Certificationstatus: '认证状态',
        Enterprisename: '企业名称',
        Applicationtime: '申请时间',
        ProjectNo: 'BSI项目编号',
        ApplicationNo: '申请编号',
        search: 'Search',
        export: '导出项目列表',
        cycle: '盘查周期: ',
        total: '总排放量:  ',
        applicationNo1: '申请编号:',
        applicationTime: '申请时间:',
        Updatetime: '更新时间:',
        contacts: 'MVGX 联系人: ',
    },
    page1: {
        carbon: "碳中和指数评级报告",
        company: '被评公司:',
        report: '报告周期：',
        score: '得分：',
        grade: '等级：',
        Evaluation: '评估时间：',
        headquarters: '总部所在地：',
        EnterpriseIndustry: '企业行业：',
        EnterpriseScale: '企业规模：',
        CarbonNeutralTarget: '碳中和目标：',
        ReportTo: '本报告由CarbonSpace委托TÜV SÜD出具并发布',
    },
    page2: {
        menu: '目录',
        Background: '背景介绍',
        Comprehensive: '综合评价',
        Operational: '运营排放',
        IndustrialChainEmissions: '产业链排放',
        DirectEmission: '直接减排贡献',
        IndirectEmission: '间接减排贡献',
        ZeroCarbonOperation: '零碳运营',
        GreenSupplyChain: '绿色供应链',
        CommitmentsAndOmissions: '承诺与批漏',
        ZeroCarbonInvestment: '零碳投资',
        OtherEmissions: '其他排放与减排行动',
        summary: '总结',
        appendix: '附录',
    },
    page3: {
        CarbonSpace: 'TÜV SÜD & CarbonSpace 碳中和指数评级评价报告',
        Purpose: '碳中和评级的目的',
        PurposeTxt: '气候变暖带来的种种自然灾害是人类必须面临的挑战，碳中和是全球应对气候变化的共同举措，也是全球各大经济体承担责任的方式。碳中和对企业的运营、服务、供应链管理、战略发展、投资方向等等提出了新的要求，因此，评估一家企业或者组织排放水平是否碳中和，对推进碳中和的贡献，成为评价企业可持续发展的重要维度，借此评价体系与评级，我们希望共同推动企业在碳中和方向做出更多行动。',
        EvaluationSystem: '关于碳中和运营指数评价体系',
        EvaluationSystemTxt: '碳中和指数评价体系是由零碳数字化解决方案公司“CarbonSpace” 推出，参考企业排放影响与减排贡献等相关因素，定制评价企业碳中和运营程度的评价方法，对企业多个维度的表现进行评价评分，最终给企业一个综合得分，以获得企业在碳中和方向的贡献指数。评价维度包括 ：直接排放、间接排放、直接减排贡献、间接减排贡献、零碳运营、绿色供应链、承诺与披露、零碳投资八个维度，每个维度满分100分，并有不同权重，TÜV SÜD 依据CarbonSpace标准，参考并调研企业在各个维度的披露数据与行动进行评价评分，最终根据企业表现计算企业得分与排名。',
        AppraisalIncome: '参评收益',
        AppraisalIncomeTxt: '碳中和运营指数评估可以帮助企业了解企业自身碳中和程度与行业领先水平的差距，从而管控风险；高评级的企业可以从市场中脱颖而出，意味着更好的环境友好管理水平与承担了更多的社会责任，有利于品牌建设。在评价之后，可以帮助企业在碳中和趋势下符合政策要求、降低运营成本，获得减碳收益。',
        AboutTUVSUD: "关于TÜV SÜD",
        AboutTUVSUDTxt: 'TÜV SÜD 是一家领先的国际性第三方监测认证与技术服务机构，已经有150多年的发展历史，全球销售额超 25 亿欧元。在可持续发展与碳中和领域，我们致力于为可持续发展、数字化、去碳化提供一站式第三方服务。',

    },
    page4: {
        EvaluationResults: '评价结果',
        bronze: '青铜',
        GeneralPerformance: '一般表现',
        silver: '白银',
        gold: '黄金',
        Excellent: '非常优秀',
        platinum: '白金',
        TopPerformance: '顶级表现',
        Diamonds: '钻石',
        TopPerformances: '最高表现',
        EvaluationOverview: '评价总览',
        OperationalEmissions: '运营排放',
        Weight: '权重',
        IndustrialChainEmissions: '产业链排放',
        reductionContribution: '直接减排贡献',
        IndirectEmission: '间接减排贡献',
        ZeroCarbonOperation: '零碳运营',
        GreenSupplyChain: '绿色供应链',
        CommitmentAndDisclosure: '承诺与披露',
        ZeroCarbonInvestment: '零碳投资',
    },
    botom: {
        RatingEnterprise: '评级企业',
        Grade: '等级',
        industry: '行业',
        date: '时间',
    }
}